/** global: Craft */
/** global: Garnish */
/**
 * Element Action Trigger
 */
Craft.ElementActionTrigger = Garnish.Base.extend(
  {
    maxLevels: null,
    newChildUrl: null,
    $trigger: null,
    $selectedItems: null,
    triggerEnabled: true,

    init: function (settings) {
      if (!$.isPlainObject(settings)) {
        settings = {};
      }

      // batch => bulk
      if (typeof settings.batch !== 'undefined') {
        settings.bulk = settings.batch;
        delete settings.batch;
      }
      Object.defineProperty(settings, 'batch', {
        get() {
          return this.bulk;
        },
        set(v) {
          this.bulk = v;
        },
      });

      this.setSettings(settings, Craft.ElementActionTrigger.defaults);

      const triggerId =
        Craft.formatInputId(this.settings.type) + '-actiontrigger';
      this.$trigger = $('#' + triggerId);

      if (
        !this.$trigger.length &&
        Craft.elementIndex &&
        Craft.elementIndex._$triggers
      ) {
        this.$trigger = Craft.elementIndex._$triggers.find('#' + triggerId);

        if (!this.$trigger.length) {
          Craft.elementIndex._$triggers.find('.menubtn').each((i, btn) => {
            const menuBtn = $(btn).data('menubtn');

            if (menuBtn?.menu?.$container) {
              const $trigger = menuBtn.menu.$container.find('#' + triggerId);

              if ($trigger.length) {
                this.$trigger = $trigger;
                return false;
              }
            }
          });
        }
      }

      // Do we have a custom handler?
      if (this.settings.activate) {
        // Prevent the element index's click handler
        this.$trigger.data('custom-handler', true);

        // Is this a custom trigger?
        if (this.$trigger.prop('nodeName') === 'FORM') {
          this.addListener(this.$trigger, 'submit', 'handleTriggerActivation');
        } else {
          this.addListener(
            this.$trigger,
            'activate',
            'handleTriggerActivation'
          );
        }
      }

      this.updateTrigger();
      Craft.elementIndex.on('selectionChange', this.updateTrigger.bind(this));
    },

    updateTrigger: function () {
      // Ignore if the last element was just unselected
      if (Craft.elementIndex.getSelectedElements().length === 0) {
        return;
      }

      if (this.validateSelection()) {
        this.enableTrigger();
      } else {
        this.disableTrigger();
      }
    },

    /**
     * Determines if this action can be performed on the currently selected elements.
     *
     * @returns {boolean}
     */
    validateSelection: function () {
      this.$selectedItems = Craft.elementIndex.getSelectedElements();

      if (!this.settings.bulk && this.$selectedItems.length > 1) {
        return false;
      }

      if (this.settings.requireId) {
        for (let i = 0; i < this.$selectedItems.length; i++) {
          const $item = this.$selectedItems.eq(i);
          if (!Garnish.hasAttr($item, 'data-id') || $item.is('[data-id=""]')) {
            return false;
          }
        }
      }

      if (typeof this.settings.validateSelection === 'function') {
        return this.settings.validateSelection(this.$selectedItems);
      }

      return true;
    },

    enableTrigger: function () {
      if (this.triggerEnabled) {
        return;
      }

      this.$trigger.removeClass('disabled').removeAttr('aria-disabled');
      this.triggerEnabled = true;
    },

    disableTrigger: function () {
      if (!this.triggerEnabled) {
        return;
      }

      this.$trigger.addClass('disabled').attr('aria-disabled', 'true');
      this.triggerEnabled = false;
    },

    handleTriggerActivation: function () {
      if (this.triggerEnabled) {
        this.settings.activate(this.$selectedItems);
      }
    },
  },
  {
    defaults: {
      type: null,
      bulk: true,
      requireId: true,
      validateSelection: null,
      activate: null,
    },
  }
);
